import { render, staticRenderFns } from "./ProductizeTransformedAttributeHistory.vue?vue&type=template&id=c1501a36&scoped=true"
import script from "./ProductizeTransformedAttributeHistory.vue?vue&type=script&lang=js"
export * from "./ProductizeTransformedAttributeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1501a36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1501a36')) {
      api.createRecord('c1501a36', component.options)
    } else {
      api.reload('c1501a36', component.options)
    }
    module.hot.accept("./ProductizeTransformedAttributeHistory.vue?vue&type=template&id=c1501a36&scoped=true", function () {
      api.rerender('c1501a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/components/ProductizeTransformedAttributeHistory.vue"
export default component.exports